import React from "react";
import BackButton from "../../main/BackButton";
import Video from "../../main/Video";

const Collection18Video = () => {
  return (
    <>
      <BackButton url="/allvideos" />
      <Video
        url={`https://yuriy-dmytrash19.wistia.com/medias/gy8o4nzsh3`}
        maxHeight="80%"
      />
    </>
  );
};

export default Collection18Video;
